import React from "react";
import { LegalPage, LegalSection, LegalList } from "@/components/LegalPage";

const Terms = () => {
  return (
    <LegalPage
      overline="Legal"
      title="Terms of Use"
      effectiveDate="March 2026"
      testId="terms-page"
    >
      <p>
        These Terms of Use ("Terms") govern your access to and use of the
        website operated by <strong className="text-navy">Taonga OÜ</strong>, a
        private limited company registered in Estonia. By accessing or using
        the website, you agree to be bound by these Terms.
      </p>

      <LegalSection number={1} title="About This Website">
        <p>
          The website is provided for general information about Taonga OÜ and
          its real estate-related activities. It does not constitute an offer,
          solicitation or recommendation of any kind. Taonga OÜ does not
          provide regulated financial services, brokerage, portfolio
          management or investment advice to third parties.
        </p>
      </LegalSection>

      <LegalSection number={2} title="No Professional Advice">
        <p>
          Information on this website is provided for general informational
          purposes only and should not be relied upon as legal, tax, financial,
          investment or other professional advice. You should obtain
          appropriate professional advice before taking any action based on
          information found here.
        </p>
      </LegalSection>

      <LegalSection number={3} title="No Solicitation">
        <p>
          Nothing on this website constitutes a public offer, advertisement or
          solicitation of any kind. Taonga OÜ operates exclusively with its
          own corporate capital and does not accept public deposits or manage
          third-party client assets.
        </p>
      </LegalSection>

      <LegalSection number={4} title="Intellectual Property">
        <p>
          All content on this website — including text, graphics, layouts,
          logos, images and the underlying source code — is owned by or
          licensed to Taonga OÜ and is protected by applicable intellectual
          property laws. The "Taonga" name and logotype are trademarks of
          Taonga OÜ.
        </p>
      </LegalSection>

      <LegalSection number={5} title="Permitted Use">
        <p>You may view and use this website for personal, non-commercial business reference. You may not:</p>
        <LegalList
          items={[
            "Reproduce, distribute or publicly display content from the site without prior written consent",
            "Use the site or its content for any unlawful purpose",
            "Reverse-engineer or attempt to extract source code (beyond what is publicly served)",
            "Use automated means to harvest data, including scraping or screen-scraping",
            "Interfere with the operation, security or integrity of the website",
          ]}
        />
      </LegalSection>

      <LegalSection number={6} title="Third-Party Links">
        <p>
          The website may contain references or links to third-party websites
          or services (for example, established real estate platforms). Taonga
          OÜ does not control and is not responsible for the content,
          availability or practices of such third parties.
        </p>
      </LegalSection>

      <LegalSection number={7} title="Disclaimer">
        <p>
          The website and its content are provided on an <em>"as is"</em> and{" "}
          <em>"as available"</em> basis. To the maximum extent permitted by
          law, Taonga OÜ disclaims all warranties of any kind, whether express
          or implied, including warranties of merchantability, fitness for a
          particular purpose, accuracy or non-infringement.
        </p>
      </LegalSection>

      <LegalSection number={8} title="Limitation of Liability">
        <p>
          To the extent permitted by applicable law, Taonga OÜ shall not be
          liable for any indirect, incidental, special, consequential or
          punitive damages arising out of or in connection with your access to
          or use of the website.
        </p>
      </LegalSection>

      <LegalSection number={9} title="Privacy">
        <p>
          Your use of the website is also governed by our Privacy Policy and
          Cookie Notice, which form an integral part of these Terms.
        </p>
      </LegalSection>

      <LegalSection number={10} title="Governing Law and Jurisdiction">
        <p>
          These Terms are governed by the laws of the Republic of Estonia, and
          any dispute arising in connection with them shall be submitted to
          the exclusive jurisdiction of the competent Estonian courts, unless
          mandatory law provides otherwise.
        </p>
      </LegalSection>

      <LegalSection number={11} title="Changes">
        <p>
          We may update these Terms from time to time. The most current
          version will always be available on this page with the updated
          effective date. Continued use of the website after such updates
          constitutes acceptance of the revised Terms.
        </p>
      </LegalSection>

      <LegalSection number={12} title="Contact">
        <p>
          Questions about these Terms can be directed to{" "}
          <a
            href="mailto:info@taonga.eu"
            className="text-navy hover:text-warm transition-colors"
          >
            info@taonga.eu
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default Terms;
